import { createStyles } from 'antd-style';

export const useNoticeSectionStyles = createStyles(({ token }) => ({
  notice: {
    marginTop: token.margin,
    fontSize: token.fontSizeSM,
    fontWeight: 400,
  },
}));
